var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9317 50L96.4915 20.4426C101.169 15.7654 101.169 8.18326 96.4915 3.50848C91.8191 -1.1663 84.2322 -1.1663 79.5598 3.50848L50 33.0707L20.4402 3.50848C15.7678 -1.1663 8.18086 -1.1663 3.50847 3.50848C-1.1687 8.18565 -1.1687 15.7678 3.50847 20.4426L33.0659 50L3.50847 79.5574C-1.1687 84.2346 -1.1687 91.8167 3.50847 96.4915C5.84347 98.8313 8.91129 99.9976 11.9743 99.9976C15.035 99.9976 18.1052 98.8313 20.4402 96.4915L50 66.9341L79.5598 96.4939C81.8972 98.8337 84.9626 100 88.0257 100C91.0887 100 94.1565 98.8337 96.4915 96.4939C101.169 91.8167 101.169 84.2346 96.4915 79.5598L66.9317 50Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f705e423ea745ef7821ba34b8f565160.svg";
export { ForwardRef as ReactComponent };